//Router
import { router } from '.';
import {
  type RouteLocationNormalized,
  type RouteParamsRaw,
  type RouteRecordRaw,
  useRoute,
  type LocationQuery,
} from 'vue-router';

export const rotaAtual = useRoute;

export async function irParaRota(rota: RouteRecordRaw | string, query?: RouteParamsRaw) {
  const path = typeof rota === 'string' ? rota : rota.path;
  if (query) {
    Object.assign(path, { query });
  }

  await router.push(path);
}

export async function irParaRotaName(rota: RouteRecordRaw | string, params?: RouteParamsRaw) {
  const rotaName = typeof rota === 'string' ? { name: rota } : { name: String(rota.name) };

  if (params) {
    Object.assign(rotaName, { params });
  }

  await router.push(rotaName);
}

export function irParaRotaAtualComCliente(pCliente: number) {
  if (!pCliente) {
    console.warn('Cliente não definido na sessão');
    return;
  }

  const cliente = String(pCliente);
  const currentRoute = router.currentRoute.value;

  // Se já está na rota com o cliente correto, não precisa redirecionar
  if (currentRoute.params.cliente === cliente) {
    return;
  }

  router.replace({
    name: currentRoute.name as string,
    params: {
      ...currentRoute.params,
      cliente,
    },
    query: currentRoute.query,
    hash: currentRoute.hash,
  });
}

export function irParaRotaLogin(to?: RouteLocationNormalized, from?: RouteLocationNormalized) {
  if (from?.path.includes('auth')) {
    //return
  }

  //Se a rota atual for a de login, não redireciona
  if (to?.path.includes('auth')) {
    return;
  }

  //Armazena a rota desejada em que o usuário queria acessar
  //para redirecionar após o login
  const redirect = to?.path ? `?redirect=${to.path}` : '';
  const isRotaAdmin = to?.meta.routeAdmin ?? false;

  if (isRotaAdmin) {
    //Se a rota atual for a de admin, redireciona para a rota de login do admin
    return router.push(`/admin/login${redirect}`);
  }

  //router.back()
  router.push(`/auth/login${redirect}`);
}

export function avancarParaRota(rota: RouteRecordRaw | string, query?: RouteParamsRaw, id?: string | number) {
  rota = typeof rota === 'string' ? rota : rota.path;

  if (id) {
    rota = rota.replace(':id', `${id}`);
  }

  const route = { path: `${router.currentRoute.value.path}/${rota}` };

  if (query) {
    Object.assign(route, { query });
  }

  router.push(route);
}

export function voltarPaginaAnterior() {
  const rotas = router.currentRoute.value.matched;
  let paginaAnterior = rotas[rotas.length - 2].path;

  if (!paginaAnterior) {
    paginaAnterior = rotas[rotas.length - 3].path;
  }

  router.push(paginaAnterior);
}

export function obterNameRota(): string {
  const route = router.currentRoute.value;

  if (!route.name) {
    console.warn(
      `[Alerta de Rota] A tela atual (${route.path}) não possui a propriedade 'name' definida no Vue Router!`,
    );
    return '';
  }

  return route.name.toString();
}

export function obterQueryRota(): LocationQuery {
  return router.currentRoute.value.query;
}

export function obterParametroRota() {
  return router.currentRoute.value.params;
}

/**
 *  Função que retorna o nome da rota "PAI" atual
 *  - Diz respeito ao qual DW o layout está mostrando
 *  - Utilizado para saber qual DW está sendo exibido
 *  - Exemplo: DWVendas, DWFinanceiro, DWEstoque etc...
 */
export function obterInfoDWAtual(): string {
  try {
    const rotaAtual = router.currentRoute.value;
    const nomeDaRota = rotaAtual.matched[0].children[0].name;
    return nomeDaRota as string;
  } catch (error) {
    console.error('Erro ao obter o nome da rota atual', error);
    return '';
  }
}

/**
 * Função que retorna o nome do dashboard atual (rota "FILHA" do DW atual)
 * - Diz respeito ao qual dashboard está sendo exibido
 * - Utilizado para saber qual dashboard está sendo exibido
 * - Exemplo: EvolucaoDeVendas e etc...
 */
export function obterInfoDashboardAtual(): string {
  try {
    const rotaAtual = router.currentRoute.value;

    // biome-ignore lint/style/noNonNullAssertion: -
    const nomeDashboard = rotaAtual.matched[0].children[0].children![1].name;

    if (!nomeDashboard) {
      throw `Não foi possível obter o nome do dashboard atual. Verifique se a estrutura das rotas está corretamente configurada`;
    }

    return nomeDashboard as string;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/*
export function obterClasseDWRotaAtual(): CModelObjeto<any, any> | null {
  try {
    const rotaAtual = router.currentRoute.value;
    console.log('Rota Atual: ', rotaAtual);
    const classe = rotaAtual.meta.classe as CModelObjeto<any, any>;

    if (!classe) {
      throw `
        Não foi encontrada a classe de cadastro que representa o dashboard referente a rota atual.
        As classes devem ser informadas no arquivo de rotas na seção de metadados
        `;
    }

    return classe;
  } catch (error) {
    console.error(error);
    return null;
  }
}

*/
